'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var cx = require('classnames');
var alloyImageGrid_module = require('./alloy-image-grid.module.scss.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var ImageGrid = function (_a) {
    var _b = _a.images, images = _b === void 0 ? [] : _b, _c = _a.imageGridWidth, imageGridWidth = _c === void 0 ? '100%' : _c, _d = _a.imageGridHeight, imageGridHeight = _d === void 0 ? '100%' : _d;
    var IMAGE_PRESET = 'pcc-pdp2';
    var defaultImageTitle = 'Default Image Title';
    var imageWidth = '100%';
    var imageHeight = '100%';
    var getImagePreset = function (img, preset) {
        return img ? "".concat(img === null || img === void 0 ? void 0 : img.split('?')[0], "?$").concat(preset, "$") : '';
    };
    return (jsxRuntime.jsx("div", tslib.__assign({ className: "d-flex flex-wrap bg-white mx-auto", "data-testid": "image-grid", style: { width: imageGridWidth, height: imageGridHeight } }, { children: images.map(function (image, index) {
            var _a;
            return index < 4 && (jsxRuntime.jsxs("div", tslib.__assign({ "data-testid": "image-tile", className: cx__default.default((_a = {
                        'w-100 h-100 d-flex': images.length === 1,
                        'w-50 h-50 d-flex': images.length > 1,
                        'my-auto': images.length === 2
                    },
                    _a["w-100 ".concat(alloyImageGrid_module.default['image-grid-standalone'])] = images.length === 3 && index === 0,
                    _a["position-relative ".concat(alloyImageGrid_module.default['image-count-badge-wrapper'])] = index === 3 && images.length > 4,
                    _a)) }, { children: [jsxRuntime.jsx("img", { className: "mh-100 mw-100 d-block", "data-testid": "thumbnail-image", src: getImagePreset(image.url, IMAGE_PRESET), alt: image.title || defaultImageTitle, width: imageWidth, height: imageHeight, loading: "lazy" }), index === 3 && images.length > 4 && (jsxRuntime.jsx("span", tslib.__assign({ className: "position-absolute d-flex justify-content-center align-items-center fw-bold image-picker__badge-count top-0 bottom-0 start-0 end-0 ".concat(alloyImageGrid_module.default['alloy-image-count-badge']) }, { children: "+".concat(images.length - 4) })))] }), "".concat(image.url, " - ").concat(index)));
        }) })));
};
var ImageGrid$1 = ImageGrid;

exports.default = ImageGrid$1;
//# sourceMappingURL=ImageGrid.js.map
